import {
  SET_APD_CAROUSEL_DATA,
  UPDATE_APD_CAROUSEL_DATA,
} from 'legacy/src/constants/types';

export default function setAPDCarouselData({ subject, videoData }) {
  return (dispatch) => {
    dispatch({
      type: SET_APD_CAROUSEL_DATA,
      payload: videoData,
      subject,
    });
  };
}

export function updateSingleVideoAPDCarouselData({
  subject,
  videoId,
  playTimePercentage,
}) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_APD_CAROUSEL_DATA,
      payload: playTimePercentage,
      subject,
      videoId,
    });
  };
}
